import { createAction } from "redux-actions";

export const PRODUCT_LIST = "PRODUCT_LIST";
export const productList = createAction(PRODUCT_LIST);

export const PRODUCT_DETAILS = "PRODUCT_DETAILS";
export const productDetails = createAction(PRODUCT_DETAILS);

export const ADD_PRODUCT = "ADD_PRODUCT";
export const addProduct = createAction(ADD_PRODUCT);

export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const updateProduct = createAction(UPDATE_PRODUCT);

export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const deleteProduct = createAction(DELETE_PRODUCT);

export const PREVIEW_BULK_PRODUCT = "PREVIEW_BULK_PRODUCT";
export const previewBulkProduct = createAction(PREVIEW_BULK_PRODUCT);

export const UPLOAD_BULK_PRODUCT = "UPLOAD_BULK_PRODUCT";
export const uploadBulkProduct = createAction(UPLOAD_BULK_PRODUCT);

export const ALL_PRODUCTS = "ALL_PRODUCTS";
export const allProducts = createAction(ALL_PRODUCTS);

export const UPLOAD_SYNC_PRODUCTS = "UPLOAD_SYNC_PRODUCTS";
export const uploadSyncProducts = createAction(UPLOAD_SYNC_PRODUCTS);

export const UPLOAD_SYNC_IMAGE = "UPLOAD_SYNC_IMAGE";
export const syncProductsImage = createAction(UPLOAD_SYNC_IMAGE);
